export default "__VITE_ASSET__DnoReKLj__"